import { AddressInfo, Job, JobCategory, LatLng } from '../types'
import { JobType } from '../types/enums/JobType'
import { AdditionalItemStatus } from '../types/enums/AdditionalItemStatus'
import images from '../images'
import { JobStatus } from '../types/enums'

const activeStatuses = [
    JobStatus.ACCEPTED,
    JobStatus.BIDDING_ACTIVE,
    JobStatus.BIDS_AWAITING_ACCEPTANCE,
    JobStatus.CONFIRM_ARRIVAL,
    JobStatus.CREATED,
    JobStatus.HAULER_ARRIVING,
    JobStatus.UNDER_REVIEW,
    JobStatus.WAITING_FOR_PAYMENT_AUTHORIZATION
]

export default class JobUtils {
    static isCancelledJob = (job: Job) => {
        switch (job.status) {
            case JobStatus.CANCELLED_BY_CUSTOMER:
            case JobStatus.DECLINED_BY_HAULER:
            case JobStatus.DECLINED_AUTO:
            case JobStatus.DECLINED_BY_CUSTOMER:
                return true
            default:
                return false
        }
    }

    static guid() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1)
        }
        return (
            s4() +
            s4() +
            '-' +
            s4() +
            '-' +
            s4() +
            '-' +
            s4() +
            '-' +
            s4() +
            s4() +
            s4()
        )
    }

    static isCompletedJob = (job: Job) => {
        return job.status === JobStatus.COMPLETED
    }
    static isActiveJob = (job: Job) => {
        return activeStatuses.indexOf(job.status) >= 0
    }
    static getJobType(job: Job): JobType | null {
        if (job) {
            if (job.jobItems && job.jobItems.length > 0) {
                return JobType.CountBasedJob
            } else {
                return JobType.QuickHaul
            }
        }
        return null
    }
    static getJobCategoryName = (job: Job) => {
        if (job) {
            if (job.jobCategory) {
                return job.jobCategory.name
            }
            return JobUtils.getJobType(job) === JobType.QuickHaul
                ? 'Quick Haul'
                : 'Yard Debris'
        }
        return undefined
    }
    static getFullAmount(job: Job) {
        if (job && job.amount) {
            let fullAmount = job.amount
            if (job.additionalItem) {
                if (
                    job.additionalItem.status ===
                        AdditionalItemStatus.ACCEPTED ||
                    job.additionalItem.status === AdditionalItemStatus.CHARGED
                ) {
                    fullAmount += job.additionalItem.amount as number
                }
            }
            return fullAmount
        }
        return undefined
    }
    static getFinalAmount = (job: Job): number | undefined => {
        let price =
            job.status === JobStatus.COMPLETED
                ? JobUtils.getFullAmount(job)
                : undefined
        if (JobUtils.isCancelledJob(job) && (job.hauler || job.haulerId)) {
            price = job.cancellationFeeFromClient
                ? job.cancellationFeeFromClient
                : undefined
        }
        return price
    }
    static getImageForCategory(jobCategory: JobCategory) {
        if (jobCategory) {
            switch (jobCategory.name) {
                case 'Yard Debris':
                    return images.yardDebris
                case 'Recycle':
                    return images.recycle
                case 'Junk':
                    return images.junk
                case 'Quick Haul':
                default:
                    return images.quickHaul
            }
        }
    }

    static buildAddress = (address?: AddressInfo) => {
        if (address) {
            if (address.apartmentNumber) {
                return (
                    `${address.streetName}` +
                    ', #' +
                    address.apartmentNumber +
                    '\n' +
                    address.city +
                    ', ' +
                    address.region +
                    ' ' +
                    address.zipCode
                )
            } else {
                return (
                    `${address.streetName}` +
                    '\n' +
                    address.city +
                    ', ' +
                    address.region +
                    ' ' +
                    address.zipCode
                )
            }
        } else {
            return ''
        }
    }

    static getJobCoordinates(coordinates?: string): LatLng {
        if (coordinates) {
            let latlng = coordinates.split(',')
            return {
                lat: Number(latlng[0]),
                lng: Number(latlng[1])
            }
        } else {
            return {
                lat: 0,
                lng: 0
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/utils/JobUtils.ts